export default function updateNewSoftwareVersionsCount(count) {
    return {
        type: updateNewSoftwareVersionsCount.type,
        payload: count,
    };
}

updateNewSoftwareVersionsCount.type = 'UPDATE_NEW_SOFTWARE_VERSIONS_COUNT';
